module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-01-m.0537f6c35a420b04a10fd591fd4e8928.png";